import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'rs-confirmation',
  templateUrl: 'confirmation.component.html',
  styleUrls: ['confirmation.component.scss']
})
export class ConfirmationPopupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public text: boolean
  ) {}

}
